import { useState, useEffect } from 'react';

// Custom hook to track URL search params reactively
export const useReactiveURLSearchParams = () => {
  const [urlSearchParams, setUrlSearchParams] = useState(() => {
    return Object.fromEntries(new URL(window.location.href).searchParams);
  });

  useEffect(() => {
    const handleLocationChange = () => {
      const newParams = Object.fromEntries(
        new URL(window.location.href).searchParams
      );
      setUrlSearchParams(newParams);
    };

    // Listen for browser navigation events
    window.addEventListener('popstate', handleLocationChange);
    // Listen for pushstate/replacestate events (when using history.pushState)
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(window.history, args);
      handleLocationChange();
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(window.history, args);
      handleLocationChange();
    };

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return urlSearchParams;
};
